import { Link } from 'react-router-dom';

export default function Safety() {
  const points = [
    {
      icon: 'ri-lock-line',
      title: 'Szyfrowanie end-to-end',
      desc: 'Wszystkie dane przesyłane i przechowywane w USFansSpreadsheet są chronione za pomocą szyfrowania AES-256, co zapewnia najwyższy poziom bezpieczeństwa.',
    },
    {
      icon: 'ri-server-line',
      title: 'Bezpieczne serwery',
      desc: 'Infrastruktura USFansSpreadsheet opiera się na certyfikowanych centrach danych z całodobowym monitoringiem i ochroną fizyczną.',
    },
    {
      icon: 'ri-history-line',
      title: 'Kopie zapasowe',
      desc: 'Automatyczne kopie zapasowe są tworzone codziennie, dzięki czemu nigdy nie stracisz swoich danych nawet w przypadku awarii.',
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Kontrola dostępu',
      desc: 'Zaawansowany system uprawnień pozwala precyzyjnie kontrolować, kto ma dostęp do poszczególnych arkuszy i jakie operacje może wykonywać.',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20white%20ceramic%20padlock%20sculpture%20on%20cream%20marble%20pedestal%2C%20with%20olive%20branch%20and%20soft%20linen%20fabric%2C%20warm%20natural%20sunlight%2C%20clean%20modern%20gallery%20aesthetic%2C%20peaceful%20secure%20atmosphere%2C%20editorial%20product%20photography&width=800&height=600&seq=safety-new-img-p3&orientation=landscape"
                alt="USFansSpreadsheet bezpieczeństwo danych - ochrona i szyfrowanie"
                title="USFansSpreadsheet - bezpieczeństwo danych"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Bezpieczeństwo
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Czy USFansSpreadsheet jest bezpieczny? Fakty i opinie użytkowników
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6">
              Bezpieczeństwo danych to jeden z najważniejszych aspektów przy wyborze narzędzia do zarządzania arkuszami. 
              <strong className="text-foreground-950"> USFansSpreadsheet</strong> stosuje wielowarstwowe zabezpieczenia, 
              aby chronić Twoje informacje przed nieautoryzowanym dostępem.
            </p>

            <div className="space-y-4 mb-6">
              {points.map((point) => (
                <div key={point.title} className="flex gap-3">
                  <span className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mt-0.5">
                    <i className={point.icon}></i>
                  </span>
                  <div>
                    <h3 className="font-semibold text-foreground-950 text-sm mb-1">{point.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Dowiedz się więcej o bezpieczeństwie
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}